import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import moment from 'moment';

import { Tabela } from '~/components';
import { t } from '~/helpers';
import dateTime from '~/hooks/DateTime';
import {
  operacaoRecebimentosInRequest,
  deleteOperacaoRecebimento,
  findOperacaoRecebimento,
  recordFiltering,
} from '~/store/modules/operacaorecebimento/actions';

import OperacaoRecebimentoForm from './form';

function OperacaoRecebimentoList() {
  const operacaorecebimento = useSelector((state) => state.operacaorecebimento);

  const [serverDate, setServerDate] = useState(null);

  useEffect(() => {
    async function handleGetDate() {
      const date = await dateTime();
      await setServerDate(date);
    }

    handleGetDate();
  }, []);

  return (
    <>
      {serverDate && (
        <Tabela
          read={operacaoRecebimentosInRequest}
          remove={deleteOperacaoRecebimento}
          state={operacaorecebimento}
          header={[
            {
              id: 'datahorainiciodescarga',
              label: t('s.operacao.recebimento.datahorainiciodescarga'),
              format: (value) => moment(value).format('DD/MM/YYYY HH:mm'),
              filter: {
                type: 'initialdatetime',
                defaultValue: serverDate
                  .set({ hour: 0, minute: 0, second: 0 })
                  .format('YYYY-MM-DDTHH:mm'),
              },
            },
            {
              id: 'datahorafimdescarga',
              label: t('s.operacao.recebimento.datahorafimdescarga'),
              format: (value) => moment(value).format('DD/MM/YYYY HH:mm'),
              filter: {
                type: 'finaldatetime',
                defaultValue: serverDate
                  .set({ hour: 23, minute: 59, second: 59 })
                  .format('YYYY-MM-DDTHH:mm'),
              },
            },
            {
              id: 'nomeposto',
              label: t('s.operacao.recebimento.nomeposto'),
              filter: {
                type: 'text',
              },
            },
            {
              id: 'numeronfdescarga',
              label: t('s.operacao.recebimento.numeronfdescarga'),
              filter: {
                type: 'text',
              },
              align: 'right',
            },
            {
              id: 'volumenfdescarga',
              label: t('s.operacao.recebimento.volumenfdescarga'),
              filter: {
                type: 'number',
              },
              align: 'right',
            },
            {
              id: 'placactdescarga',
              label: t('s.operacao.recebimento.placactdescarga'),
              filter: {
                type: 'text',
              },
            },
            {
              id: 'codigousuario',
              label: t('s.operacao.recebimento.codigousuario'),
              filter: {
                type: 'text',
              },
            },
          ]}
          headerMobile="nomeposto"
          unique={['iddescarga']}
          form={OperacaoRecebimentoForm}
          findItem={findOperacaoRecebimento}
          recordFilter={recordFiltering}
        />
      )}
    </>
  );
}

export default OperacaoRecebimentoList;
